<h1 mat-dialog-title>{{ 'properties.detail.adminCompanyPrivacySagDialog.title' | translate }}</h1>
<mat-dialog-content class="admin-company-privacy-sag-dialog">
  <p>{{ 'properties.detail.adminCompanyPrivacySagDialog.intro' | translate }}</p>

  <div class="privacy-sag-row">
    <button
      mat-flat-button
      type="button"
      color="accent"
      class="privacy-sag-btn"
      (click)="onGenerateDocuments()">
      {{ 'properties.detail.adminCompanyPrivacySagDialog.generateBtn' | translate }}
    </button>
    <span class="privacy-sag-label">{{ 'properties.detail.adminCompanyPrivacySagDialog.generateLabel' | translate }}</span>
  </div>

  <p *ngIf="data.hasLeaseContracts" class="privacy-sag-note">
    <i class="fal fa-info-circle"></i>
    <span>{{ 'properties.detail.adminCompanyPrivacySagDialog.leaseContractsNote' | translate }}</span>
  </p>

  <div class="privacy-sag-row" *ngIf="data.hasCaretaker">
    <button
      mat-flat-button
      type="button"
      color="warn"
      class="privacy-sag-btn"
      [disabled]="caretakerDocDownloading"
      (click)="onDownloadCaretakerDoc()">
      <mat-spinner *ngIf="caretakerDocDownloading" strokeWidth="2" [diameter]="16" class="d-inline-block"></mat-spinner>
      <span *ngIf="!caretakerDocDownloading">
        {{ 'properties.detail.adminCompanyPrivacySagDialog.downloadBtn' | translate }}
      </span>
    </button>
    <span class="privacy-sag-label">{{ 'properties.detail.adminCompanyPrivacySagDialog.caretakerLabel' | translate }}</span>
  </div>
</mat-dialog-content>
<div class="row" mat-dialog-actions>
  <div class="col-12 text-right">
    <button mat-raised-button (click)="onClose()">
      {{ 'properties.detail.adminCompanyPrivacySagDialog.ignoreAndContinueBtn' | translate }}
    </button>
  </div>
</div>
